<template>
  <div
    class="footer-box"
    :class="{ 'footer-box-default': !dataSource || dataSource.length <= 0 }"
  >
    <div class="links" v-if="dataSource && dataSource.length > 0">
      友情链接：
      <a
        v-for="(item, index) in dataSource"
        :key="index"
        :href="item.url"
        target="_blank"
        class="link-item"
        >{{ item.title }}</a
      >
      <!-- <a href="https://www.5118.com" target="_blank" class="link-item">5118站长工具</a>
      <a href="https://xiaomark.com/" target="_blank" class="link-item">短网址工具</a>
      <a href="http://www.iqingua.com/" target="_blank" class="link-item">青瓜传媒</a>
      <a href="https://www.cifnews.com/live" target="_blank" class="link-item">跨境电商直播</a>
      <a href="https://ai-bot.cn" target="_blank" class="link-item">AI工具集导航</a>
      <a href="https://www.aitoolist.cn/" target="_blank" class="link-item">AI工具集合网</a>
      <a href="https://nav.guidebook.top/" target="_blank" class="link-item">数字生活指南</a>
      <a href="https://fxsh.com/" target="_blank" class="link-item">潘喜导航</a>
      <a href="https://www.aidashi.cn/" target="_blank" class="link-item">AI大师</a> -->
    </div>

    <div class="content">
      Copyright © 2020 ciyun.5118.com All Rights Reserved
      <a
        style="color: white;margin-left: 10px;"
        rel="nofollow"
        href="http://beian.miit.gov.cn/"
        target="_blank"
        >粤ICP备19157206号</a
      >
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
export default {
  componentName: "footer",
  data() {
    return {
      dataSource: []
    };
  },
  computed: {},

  async mounted() {
    var result = await this.AGetFriendship();
    if (result.errorCode == 0 && result.data.rowCount > 0) {
      this.dataSource = result.data.dataSource;
    }
  },
  methods: {
    ...mapActions("course", ["AGetFriendship"])
  }
};
</script>

<style type="text/less" lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/config";
@import "../../assets/style/mixin";

.footer-box {
  background-color: black;
  height: 100px;
  /*display: flex;flex*/
  align-items: center;
}
.footer-box-default {
  background-color: black;
  height: 60px !important;
  /*display: flex;flex*/
  align-items: center;
}

.footer-box .content {
  color: white;
  text-align: center;
  font-size: 10px;
  padding-top: 25px;
}

.links {
  padding-top: 20px;
  color: white;
  font-size: 12px;
  text-align: center;
  line-height: 24px;

  .link-item {
    color: white;
    display: inline-block;
    margin-right: 15px;
  }
}
</style>
